<pp-modal [zIndex]="zIndex" [ppNoPadding]="true">
  <ng-container heading>
    {{ 'delete_site_plan' | ppTranslate }}
  </ng-container>

  <ng-container body>
    <div class="siteSettingsPlanDeleteBody">
      <pp-error-box [ppOpeningMessageKey]="'warning_permanent_deletion'"></pp-error-box>

      <p class="siteSettingsPlanDeleteMessage">
        <span>
          {{ 'delete_site_plan_message_1' | ppTranslate }} <br />
          {{ 'delete_site_plan_message_2' | ppTranslate }}
        </span>

        <span>
          {{ 'delete_site_plan_message_3' | ppTranslate }}
        </span>
      </p>
    </div>
  </ng-container>

  <ng-container footer>
    <pp-modal-generic-footer
      [ppConfirmText]="'delete_forever' | ppTranslate"
      (ppCancel)="hideModal(true)"
      (ppConfirm)="hideModal(false)"
      [ppError]="true"
      [ppHideCancel]="false"
    ></pp-modal-generic-footer>
  </ng-container>
</pp-modal>
